// extracted by mini-css-extract-plugin
export default {"wrapper":"EditUserPage-module__wrapper___HHPKa","contentWrapper":"EditUserPage-module__contentWrapper___f5hxT"};